import styled from "styled-components";

export const Description = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: white;

  h1 {
    font-size: 37px;
  }

  @media (max-width: 425px) {
    h1 {
      font-size: 25px;
    }
  }
`;
